import { useKeycloakAuth } from '@/hooks/useKeycloakAuth';
import { Navigate } from 'react-router-dom';
import { MaintenanceMode } from '@/components/MaintenanceMode';
import { RedirectToKeycloakLogin } from '@/components/RedirectToKeycloakLogin';
import { MAINTENANCE_MODE, MAINTENANCE_TITLE, MAINTENANCE_DESCRIPTION } from '@/config/maintenance';
import { usePermissions } from '@/hooks/useUnifiedAuth';
import { AccessDenied } from '@/components/AccessDenied';

interface InternalRouteProps {
  children: React.ReactNode;
}

export const InternalRoute = ({ children }: InternalRouteProps) => {
  const { isAuthenticated, isLoading } = useKeycloakAuth();
  const { isInternal } = usePermissions();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <RedirectToKeycloakLogin />;
  }

  // Verificar modo de manutenção global
  if (MAINTENANCE_MODE) {
    return <MaintenanceMode title={MAINTENANCE_TITLE} description={MAINTENANCE_DESCRIPTION} />;
  }


  // Ferramenta interna (GR-637). Antes daqui o guard só validava autenticação —
  // o card em Configuracoes.tsx é filtrado por `is_internal`, mas a URL
  // entregava a tela a qualquer usuário logado.
  if (!isInternal) {
    return <AccessDenied area="a esta área interna" />;
  }

  return <>{children}</>;
};
